<template>
    <div>
        <v-chip v-if="copyright"
                :color="colors.copyright"
                style="position: fixed !important; top: 10px; right: 10px; z-index: 1000">
            <v-icon left small>
                {{ various[language].icons.copyright }}
            </v-icon>
            by Anais Gautron
        </v-chip>
        <v-carousel v-model="carousel"
                    touchless
                    hide-delimiters
                    height="100%"
                    :show-arrows="false">
            <v-carousel-item>
                <v-card class="pt-4 pb-8"
                        :class="{ 'pt-14 pt-md-8 pb-12': copyright }"
                        :color="colors.background"
                        :dark="dark">
                    <v-card-actions class="justify-center">
                        <v-btn :color="colors.buttons"
                               class="mx-3 px-3 primary--text v-btn-not-rounded"
                               @click="nextPage()">
                            <span>{{ various[language].getStarted }}</span>
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-carousel-item>

            <v-carousel-item
                v-for="question in questions[language]"
                :key="question.title">
                <v-card class="pt-4 pb-8"
                        :class="{ 'pt-14 pt-md-8 pb-12': copyright }"
                        :color="colors.background"
                        :dark="dark">
                    <v-card-title class="justify-center text-h6" style="word-break: break-word !important; letter-spacing: -.04em !important">
                        {{ question.title }}
                    </v-card-title>
                    <v-card-subtitle class="font-weight-bold">
                        {{ various[language].step }} {{ carousel }} / {{ questions[language].length }}
                    </v-card-subtitle>
                    <v-card-text class="font-weight-bold">
                        {{ question.text }}
                    </v-card-text>
                    <v-card-actions style="width: fit-content; margin: auto" class="text-none">
                        <v-row>
                            <v-col>
                                <v-checkbox v-model="question.score"
                                            v-for="checkbox in question.checkboxes"
                                            :key="checkbox"
                                            :label="checkbox"
                                            :dark="dark"
                                            color="white"
                                            dense
                                            hide-details
                                            multiple
                                            :value="checkbox"/>
                            </v-col>
                        </v-row>
                    </v-card-actions>
                    <div class="pa-3"></div>
                    <v-card-actions class="justify-center">
                        <v-btn :color="colors.buttons"
                               v-if="carousel"
                               class="mx-3 px-3 primary--text v-btn-not-rounded"
                               @click="previousPage()">
                            <span>{{ various[language].previous }}</span>
                        </v-btn>
                        <v-btn :color="colors.buttons"
                               class="mx-3 px-3 primary--text v-btn-not-rounded"
                               @click="nextPage()">
                            <span>{{ various[language].next }}</span>
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-carousel-item>
            <v-carousel-item>
                <v-card class="pt-4 pb-8"
                        :class="{ 'pt-14 pt-md-8 pb-12': copyright }"
                        :color="colors.background"
                        :dark="dark">
                    <v-card-title class="justify-center text-h6" style="word-break: break-word !important; letter-spacing: -.04em !important">
                        {{ results[language].title }}
                    </v-card-title>
                    <v-card-text class="font-weight-bold">
                        {{ results[language].text }}
                        <v-divider class="mt-4 mb-4"/>
                    </v-card-text>
                    <v-form v-model="valid" ref="form">
                        <v-card-actions class="justify-center text-none">
                            <v-row style="width: 100vw; max-width: 500px">
                                <v-col cols="12" v-if="!sendingEmail" class="pb-6">
                                    <v-text-field :color="results[language].actions.name.color"
                                                  :label="results[language].actions.name.text"
                                                  :rules="[rules.required, rules.name]"
                                                  validate-on-blur
                                                  hide-details
                                                  ref="name"
                                                  autocomplete="name"
                                                  prefix=" "
                                                  :dark="dark"
                                                  :prepend-inner-icon="results[language].actions.name.icon"
                                                  outlined
                                                  v-model="name"
                                                  class="mx-3 px-3 pb-6 textfield"/>
                                    <v-text-field :color="results[language].actions.email.color"
                                                  :label="results[language].actions.email.text"
                                                  :prepend-inner-icon="results[language].actions.email.icon"
                                                  hide-details
                                                  ref="email"
                                                  autocomplete="email"
                                                  prefix=" "
                                                  :dark="dark"
                                                  :rules="[rules.required, rules.email]"
                                                  validate-on-blur
                                                  outlined
                                                  type="email"
                                                  v-model="email"
                                                  class="mx-3 px-3 textfield"/>
                                    <v-checkbox :label="results[language].acceptation"
                                                :rules="[rules.required]"
                                                class="ml-5 mt-6"
                                                :dark="dark"
                                                color="white"
                                                validate-on-blur
                                                v-model="acceptation"/>
                                    <v-btn :color="results[language].actions.submit.color"
                                           class="mx-3 px-3 mt-2 primary--text v-btn-not-rounded"
                                           :disabled="!valid"
                                           @click="registerAndSeeResults">
                                        {{ results[language].actions.submit.text }}
                                    </v-btn>
                                </v-col>
                                <v-col cols="12" v-else style="height: 212px" class="mt-4 pt-16">
                                    <v-progress-circular
                                        size="50"
                                        class="align-center"
                                        indeterminate
                                        color="primary"/>
                                </v-col>
                            </v-row>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-carousel-item>
            <v-carousel-item>
                <v-card class="pt-4 pb-8"
                        :class="{ 'pt-14 pt-md-8 pb-12': copyright }"
                        :color="colors.background"
                        :dark="dark">
                    <v-card-title class="justify-center text-h6" style="word-break: break-word !important; letter-spacing: -.04em !important">
                        {{ results[language].title }}
                    </v-card-title>
                    <v-card-text class="font-weight-bold">
                        <v-divider class="my-4"/>
                        <div class="ma-auto my-6" style="width: fit-content">
                            <div v-for="family in familiesToDisplay"
                                 :key="family.name"
                                 class="mx-3 px-3 my-4 text-none all-white"
                                 style="width: fit-content">
                                <span class="text-left all-white">
                                    <span v-if="family.scoreN !== -family.scoreP" class="font-weight-bold all-white body-1">
                                        {{ family.scoreP > -family.scoreN ? family.tooMuch : family.tooLittle }}:
                                    </span>
                                    <span v-else class="font-weight-bold all-white body-1">
                                        {{ family.name }}:
                                    </span>
                                    <span class="all-white font-weight-regular body-1">
                                        {{ numberOfSymptoms(family) }}
                                        <span v-if="language === 'fr'" class="font-weight-regular">
                                            Vos symptomes ne sont pas amusants, et vous pouvez faire beaucoup de choses pour y remédier.

                                            Retrouvez plus d'informations et de conseils dans l'email que je viens de vous envoyer !
                                        </span>
                                        <span v-else class="font-weight-regular">
                                            Your symptoms are no fun, and there are many things you can do about them.

                                            Find more information and advice in the email I just sent you!
                                        </span>
                                    </span>
                                </span>
                            </div>
                        </div>

                        <div v-if="Object.keys(familiesToDisplay).length === 0" class="mb-6 text-none">
                            <span class="font-weight-regular body-1">
                                {{ results[language].noSymptom.text }}
                            </span>
                        </div>
                        <div class="mb-6 text-none text-pre-line font-weight-regular body-1">
                            {{ results[language].sentByEmail }}
                        </div>

                        <v-divider class="mt-4 mb-2"/>

                    </v-card-text>
                    <v-card-actions
                        class="justify-center"
                        v-for="action in results[language].actions.buttons"
                        :key="action.text">
                        <v-btn :color="colors.buttons"
                               class="mx-3 px-3 primary--text v-btn-not-rounded"
                               :href="action.url"
                               target="_top">
                            {{ action.text }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-carousel-item>
        </v-carousel>
    </div>
</template>

<script>
import introFR from '../translations/intros/fr';
import introEN from '../translations/intros/en';
import variousFR from '../translations/various/fr';
import variousEN from '../translations/various/en';
import questionsFR from '../translations/questions/fr';
import questionsEN from '../translations/questions/en';
import resultsFR from '../translations/results/fr';
import resultsEN from '../translations/results/en';
import axios from 'axios';

export default {
    name: 'Home',
    data: function() {
        return {
            resizeObserver: null,
            copyright: false,
            acceptation: false,
            dark: true,
            name: '',
            email: '',
            valid: false,
            sendingEmail: false,
            colors: {
                background: 'transparent',
                buttons: 'white',
                copyright: 'primary',
            },
            language: 'fr',
            carousel: 0,
            questions: {
                fr: questionsFR,
                en: questionsEN,
            },
            various: {
                fr: variousFR,
                en: variousEN,
            },
            intros: {
                fr: introFR,
                en: introEN,
            },
            results: {
                fr: resultsFR,
                en: resultsEN,
            },
            rules: {
                required: value => !!value || 'Required.',
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || 'Invalid e-mail.'
                },
                name: value => {
                    const pattern = /^.+ .+$/
                    return pattern.test(value) || 'Please provide first and last names.'
                },
            },
        };
    },
    created() {
        if (this.$route.query.en !== undefined) {
            this.language = 'en';
        }
    },
    mounted() {
        window.addEventListener('message', (event) => {
            if(event.data.includes && (event.data.includes('fr') && this.language === 'en') ||
                event.data.includes  && (event.data.includes('en') && this.language === 'fr')) {
                window.location = `${location.origin}?${event.data.includes('fr') ? 'fr' : 'en'}`;
            }
        }, false);
        window.parent.postMessage(document.body.clientHeight, '*');
        this.resizeObserver = new ResizeObserver(entries =>
            window.parent.postMessage(entries[0].target.clientHeight, '*')
        );
        this.resizeObserver.observe(window.document.body);
    },
    methods: {
        scrollToTop() {
            window.scrollTo(0,0);
        },
        previousPage() {
            this.scrollToTop();
            this.carousel -= 1;
        },
        nextPage() {
            this.scrollToTop();
            this.carousel += 1;
        },
        numberOfSymptoms(value) {
            const nbOfSymptoms = (value.scoreP !== -value.scoreN)
                ? Math.max(value.scoreP, -value.scoreN)
                : value.scoreP * 2;
            return this.language === 'fr'
                ? `Vous avez coché ${nbOfSymptoms} symptômes de cette catégorie.`
                : `You have checked ${nbOfSymptoms} symptoms of this category.`;
        },
        ranking(value) {
            const nbOfSymptoms = (value.scoreP !== -value.scoreN)
                ? Math.max(value.scoreP, -value.scoreN)
                : value.scoreP * 2;
            if (nbOfSymptoms < 2) {
                return this.results[this.language].littleSymptoms;
            }
            if (nbOfSymptoms < 5) {
                return this.results[this.language].mediumSymptoms;
            }
            return this.results[this.language].heavySymptoms;
        },
        registerAndSeeResults() {
            this.sendingEmail = true;
            axios.post('https://szoztcpoz3d6ulvvc72mc7flqi0vghnt.lambda-url.us-east-1.on.aws/', {
                email: this.email,
                name: this.name,
                language: this.resultLanguage,
                symptoms: this.allSymptoms.toString(),
                diagnosis: this.diagnosis,
            });
            this.sendingEmail = false;
            // disabled redirection to web pages designed on website directly
            // window.parent.postMessage(this.redirectURL, '*');
            this.nextPage();
        },
    },
    computed: {
        diagnosis() {
            let family = this.familiesToDisplay[0];
            return family ? (family.scoreP > -family.scoreN ? family.tooMuch : family.tooLittle)
                : this.results[this.language].noSymptom.family;
        },
        resultLanguage() {
            return this.language === 'fr' ? 'fr-FR' : 'en-US';
        },
        redirectURL() {
            let family = this.familiesToDisplay[0];
            return family ? (family.scoreP > family.scoreN ? family.tooMuchURL : family.tooLittleURL)
                : 'https://www.anaisgautron.com/not-enough-symptoms';
        },
        familiesToDisplay() {
            const families = [];
            for (const category of this.questions[this.language]) {
                if (!families[category.family]) {
                    families[category.family] = {
                        name: category.family,
                        scoreP: 0,
                        scoreN: 0,
                    }
                }
                if (category.factor === 1) {
                    families[category.family].scoreP += category.score.length * category.factor;
                    families[category.family].tooMuch = category.name;
                    families[category.family].tooMuchURL = category.url;
                } else {
                    families[category.family].scoreN += category.score.length * category.factor;
                    families[category.family].tooLittle = category.name;
                    families[category.family].tooLittleURL = category.url;
                }
            }
            return Object.values(families).filter((family) => family.scoreP > 1 || -family.scoreN > 1)
                .sort((a, b) => {
                    if (a.scoreP - a.scoreN < b.scoreP - b.scoreN) {
                        return -1;
                    }
                    if (a.scoreP - a.scoreN > b.scoreP - b.scoreN) {
                        return 1;
                    }
                    // a must be equal to b
                    return 0;
                }).reverse().slice(0, this.results[this.language].maxNumberOfResults);
        },
        allSymptoms() {
            return this.questions[this.language].reduce(
                (accumulator, currentValue) => {
                    return accumulator.concat(currentValue.score)
                }, []);
        }
    }
}
</script>

<style>
html {
    overflow-y: auto !important;
}
.v-application--wrap {
    min-height: 100% !important;
}
.textfield * {
    font-size: 0.97em;
}
.theme--dark.v-label, .all-white {
    color: white !important;
}
.v-btn-not-rounded{
    border-radius: 0 !important;
    box-shadow: none !important;
}
</style>
